export default __webpack_public_path__ + "static/seniors-hero-b7c74a1628ab5e8527e883605558286d.webp";